import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useMsalAuthentication } from '@azure/msal-react';
import { ToastService, useToast } from '../../../services/toast.service';

import { AccessControl } from './AccessControl';
import { InteractionType } from '@azure/msal-browser';
import { LoginLoading } from './LoginLoading';
import { TablePage } from '../../items/components/table/TablePage';
import { useEffect } from 'react';
import { TelemetryEvent } from '../../../constants';
import capitalize from 'lodash/capitalize';
import nth from 'lodash/nth';
import { setAuthenticatedUser, trackCustomEvent } from '../../../utils';

export const AuthWrapper = () => {
   useMsalAuthentication(InteractionType.Redirect, { scopes: ['User.Read'] });
   const { instance, accounts } = useMsal();

   const toast = useToast();

   useEffect(() => {
      ToastService.setInstance(toast);
   }, [toast]);

   useEffect(() => {
      const activeAccount = instance.getActiveAccount() ?? accounts[0];
      if (!activeAccount || !activeAccount.username) return;
      setAuthenticatedUser(activeAccount?.username);
      trackCustomEvent(TelemetryEvent.AUTHENTICATED_USER, {
        email: activeAccount.username, role: capitalize(nth(activeAccount.idTokenClaims?.roles, 0)) || 'Unknown'
      });
   }, [accounts, instance]);

   return (
      <>
         <AuthenticatedTemplate>
            <AccessControl>
               <TablePage />
            </AccessControl>
         </AuthenticatedTemplate>
         <UnauthenticatedTemplate>
            <LoginLoading />
         </UnauthenticatedTemplate>
      </>
   );
};
